<template>
  <div class="fileList">
    <div class='titleBar'>
      <div >folders</div>
      <div>
        <md-icon class="icon" >view_list</md-icon >
        <md-icon class="icon active">apps</md-icon >
      </div>
    </div>
    <div class='list'>
      <div class='item'>
        <md-icon class="icon ">folder</md-icon >
        <div class='file_text'>Hexschool</div>
      </div>
      <div class='item'>
        <md-icon class="icon ">folder</md-icon >
        <div class='file_text'>Hexschool</div>
      </div>
      <div class='item'>
        <md-icon class="icon ">folder</md-icon >
        <div class='file_text'>Hexschool</div>
      </div>
            <div class='item'>
        <md-icon class="icon ">folder</md-icon >
        <div class='file_text'>Hexschool</div>
      </div>
         <div class='item'>
        <md-icon class="icon ">folder</md-icon >
        <div class='file_text'>Hexschool</div>
      </div>      <div class='item'>
        <md-icon class="icon ">folder</md-icon >
        <div class='file_text'>Hexschool</div>
      </div>   
    </div>
  </div>
</template>

<script>
export default {
  name: 'FileList',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fileList{
  padding: 24px 85px 24px 85px;
  background: #F8F8F8;
}
.titleBar{
  display: flex;
  justify-content: space-between;


}
.titleBar > div{
  text-transform: uppercase;
  text-align: center;
  align-self: center;
  font-size: 24px;
  font-style: "Helvetica Neue" bold;
  line-height: 24px;
}

 .icon{
   margin: 5px;
   color:#AAA;
 }

  .icon.active{
   color:#000;
 }

 .list{
   padding-top: 20px;
   display: flex;
   flex-direction: row;
  flex-wrap: wrap;


 }

 .item{
  width:240px;
  height: 72px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 2px 4px #00000029;
  display:flex;
  justify-content: flex-start;
  align-items: center;
  padding:8px;
  margin:8px;
  cursor: pointer;
 }

 .item:hover{
  color:#2A8CFD;
  border-top: 2px #2A8CFD solid;
  
 }


 .item:hover .icon{
   color: #2A8CFD;
 }

 .file_text{
   font-size:16px;
   font-style: 'Open Sans';
   
 }
</style>
